function testFileType(fileTypes: string[], file: string) {
    if (file) {
        var fileExtension = file.toLowerCase();
        var extensionsArray = fileTypes;
        var testCondition =
            fileExtension &&
            extensionsArray.filter(function (item) {
                return item === fileExtension;
            }).length > 0;

        return testCondition;
    }
}

function isFileText(file: string) {
    return testFileType(['txt'], file);
}

function isFilePDF(file: string) {
    return testFileType(['pdf'], file);
}

function isSVG(file: string) {
    return testFileType(['svg'], file);
}

function isFileImage(file: string) {
    return testFileType(
        ['bmp', 'gif', 'ico', 'jpeg', 'jpg', 'png', 'tif', 'tiff', 'webp'],
        file
    );
}

function isFileVideo(file: string) {
    return testFileType(['avi', 'mpeg', 'ogv', 'webm', '3g2', 'mp4'], file);
}

function fileIsWord(file: string) {
    return testFileType(['doc', 'docx', 'docm', 'dotx', 'dotm'], file);
}

function fileIsExcel(file: string) {
    return testFileType(
        ['xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'csv'],
        file
    );
}

function fileIsPowerPoint(file: string) {
    return testFileType(
        [
            'ppt',
            'pot',
            'pps',
            'potx',
            'potm',
            'ppam',
            'ppsx',
            'ppsm',
            'sldx',
            'sldm',
        ],
        file
    );
}

function isOtherFileFormat(file: string) {
    return (
        !fileIsPowerPoint(file) &&
        !fileIsExcel(file) &&
        !fileIsWord(file) &&
        !isFileVideo(file) &&
        !isFileImage(file) &&
        !isSVG(file) &&
        !isFilePDF(file) &&
        !isFileText(file)
    );
}

function isPreviewableFileFormat(file: string) {
    return (
        isFileVideo(file) ||
        isFileImage(file) ||
        isSVG(file) ||
        isFilePDF(file) ||
        isFileText(file)
    );
}

// utilities functions

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return (
        s4() +
        s4() +
        '-' +
        s4() +
        '-' +
        s4() +
        '-' +
        s4() +
        '-' +
        s4() +
        s4() +
        s4()
    );
}

function getFileExtension(fileName: string) {
    return fileName.substring(fileName.lastIndexOf('.') + 1);
}

function createPathToProp(propName: string, index: number) {
    return `${propName}[${index}]`;
}

function detectIE() {
    let ua = window.navigator.userAgent;

    /* Test values; Uncomment to check result …*/

    /* IE 10*/
    /* ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';*/

    /* IE 11*/
    /* ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';*/

    /* Edge 12 (Spartan)*/
    /* ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';*/

    /* Edge 13*/
    /* ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';*/

    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        /* IE 10 or older => return version number*/
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
        /* IE 11 => return version number*/
        let rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    let edge = ua.indexOf('Edge/');
    if (edge > 0) {
        /* Edge (IE 12+) => return version number*/
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    /* other browser*/
    return false;
}

function setDomElementValueById(elementId: string, value: any) {
    let element = document.getElementById(elementId);
    if (element != null) {
        (element as HTMLInputElement).value = value;
    }
}

export const extensionTester = {
    fileIsText: isFileText,
    fileIsPdf: isFilePDF,
    fileIsImage: isFileImage,
    fileIsVideo: isFileVideo,
    fileIsSVG: isSVG,
    fileIsExcel: fileIsExcel,
    fileIsPowerPoint,
    fileIsWord: fileIsWord,
    isOtherFileFormat,
    isPreviewableFileFormat,
    testFileType,
};

export const utilities = {
    guid,
    getFileExtension,
    createPathToProp,
    detectIE,
    setDomElementValueById
};

export const flatFiles = (files: FileList[] | File[]): File[] => {
    // Helper function to check if the input is an array of FileLists
    const isFileLists = (input: any): input is FileList[] => {
        return Array.isArray(input) && input.every(item => item instanceof FileList);
    };

    // If the input is an array of FileLists, flatten it into a single array of Files
    if (isFileLists(files)) {
        return files.reduce((acc: File[], fileList: FileList) => {
            return acc.concat(Array.from(fileList));
        }, []);
    }

    // If the input is already an array of Files, return it as is
    return files;
};